import {Component, OnInit, input} from '@angular/core';
import {Store} from '@ngrx/store';

import * as fromApp from '../../../store/app.reducers';
import * as PostActions from '../../post/store/post.actions';
import {GetExportPost} from '../../post/store/post.actions';

@Component({
    selector: 'app-export-xls',
    templateUrl: './export-xls.component.html',
    styleUrls: ['./export-xls.component.scss'],
    standalone: false
})
export class ExportXlsComponent implements OnInit {

  readonly sourceId = input<number>(undefined);
  readonly type = input<number>(undefined);

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
  }

  getExport() {
    this.store.dispatch(
      new GetExportPost({id: this.sourceId(), type: this.type(), params: {}})
    );
  }

}
